import React from "react";
import { Link } from "react-router-dom";
import { PageShell, SlideCorner } from "@/components/Layout";
import { ArrowRight } from "lucide-react";

/* ============================================================
   /build — Chooser hub. Two subsections that route to
   dedicated pages: one for artists, one for brands.
   ============================================================ */
export default function Build() {
  return (
    <PageShell>
      {/* HERO */}
      <section className="relative grid-bg border-b border-border">
        <SlideCorner right="BUILD" />
        <div className="max-w-[1600px] mx-auto px-5 md:px-10 pt-20 pb-16">
          <h1 className="font-display text-5xl md:text-7xl lg:text-[7rem] font-bold leading-[0.9] tracking-tighter">
            We help you <br /> <span className="hl-coral">become culture.</span>
          </h1>
          <p className="mt-10 max-w-2xl text-white/85 text-base md:text-lg leading-relaxed">
            Bring us what you&apos;re building. Whether you&apos;re an artist, a brand or an institution, we become your creative partner — bringing together the right people and execution to ship work that matters. All engagements are paid, scoped by conversation, and billed against a signed statement of work.
          </p>
          <p className="meta-mono mt-10 !text-white/55">
            — TWO DOORS. PICK THE ONE THAT&apos;S YOU.
          </p>
        </div>
      </section>

      {/* CHOOSER — Two large intent cards */}
      <section className="border-b border-border">
        <div className="max-w-[1600px] mx-auto grid md:grid-cols-2 gap-px bg-border">
          <ChooserCard
            testid="build-choose-artist"
            to="/build/artist"
            eyebrow="— FOR INDEPENDENT ARTISTS"
            title={<>Build <span className="hl-cyan">alongside</span> us.</>}
            body="Some projects need strategy. Others need production, distribution, partnerships or an experienced team to help move them forward. We join independent creatives at every stage of the process — always scoped to the project."
            cta="Start a project"
          />
          <ChooserCard
            testid="build-choose-brand"
            to="/build/brand"
            eyebrow="— FOR BRANDS, LABELS &amp; INSTITUTIONS"
            title={<>Tell us the <span className="hl-cyan">project.</span> We come back with a <span className="hl-coral">plan.</span></>}
            body="For brands, labels, publishers, agencies and cultural institutions looking to commission or produce work with Indian creatives. We reply with an approach and a costed proposal — no obligation to proceed."
            cta="Submit a brief"
          />
        </div>
      </section>
    </PageShell>
  );
}

function ChooserCard({ to, eyebrow, title, body, cta, testid }) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className="bg-background p-10 md:p-14 flex flex-col justify-between min-h-[420px] group hover:bg-white/[0.02] transition"
    >
      <div>
        <p className="meta-mono !text-primary mb-6" dangerouslySetInnerHTML={{ __html: eyebrow }} />
        <h2 className="font-display text-3xl md:text-5xl font-bold leading-[0.98] tracking-tight text-white">
          {title}
        </h2>
        <p className="mt-6 text-white/75 text-base leading-relaxed max-w-md">
          {body}
        </p>
      </div>
      <div className="mt-10 pt-6 border-t border-border">
        <span className="btn-pill btn-coral">
          {cta} <ArrowRight size={14} className="transition group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
}
